module.exports = __webpack_public_path__ + "img/emailspam.11b57a53.png";